export const environment = {
  production: false,
  baseUrl: "https://ondemanddev.nsurehub.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://ondemanddev.nsurehub.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "DexRLzGjnDJIyO7j8vef2N3Znqyt13eW",
  isPaymentGateWayACI:false,
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  BillingHeartlandApiKey:"4e0abc14-ecbf-4611-ba31-27d204acb3ae",
  BillingHeartlandTokenUrl:"https://devbilling.middleware.safepointdc.com/api/HeartLand/GenerateToken",
  SFpaymentResponseUrl: "https://devbilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://ondemanddev.nsurehub.com/paymentProcessAeg",
  paymentPageName:"NsurehubPortal",
  CApaymentResponseUrl: "https://devbilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://devbilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentDev = {
  production: false,
  baseUrl: "https://ondemanddev.nsurehub.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://ondemanddev.nsurehub.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "DexRLzGjnDJIyO7j8vef2N3Znqyt13eW",
  isPaymentGateWayACI:false,
  BillingHeartlandApiKey:"4e0abc14-ecbf-4611-ba31-27d204acb3ae",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  BillingHeartlandTokenUrl:"https://devbilling.middleware.safepointdc.com/api/HeartLand/GenerateToken",
  SFpaymentResponseUrl: "https://devbilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://ondemanddev.nsurehub.com/paymentProcessAeg",
  paymentPageName:"NsurehubPortal",
  CApaymentResponseUrl: "https://devbilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://devbilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentQA = {
  production: false,
  baseUrl: "https://qansurehub.middleware.safepointdc.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://qansurehub.middleware.safepointdc.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "d0999ca866254fc9b334g16207916e5d",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl:"https://qabilling.middleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey:"b1a9a0e3-c69d-4a8a-b4e5-198d30754c0e",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  paymentPageName:"NsurehubPortal",
  SFpaymentResponseUrl: "https://qabilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://qansurehub.middleware.safepointdc.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://qabilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://qabilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentTT = {
  production: false,
  baseUrl: "https://ttnsurehub.middleware.safepointdc.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://ttnsurehub.middleware.safepointdc.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "YxTFkmL4zPDJ3H8Q7vef1PsZnqrt12vW",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl:"https://ttbilling.middleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey:"f4e2c98a-6d52-40a2-9a1c-57b28fcbefce",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  paymentPageName:"NsurehubPortal",
  SFpaymentResponseUrl: "https://ttbilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://ttnsurehub.middleware.safepointdc.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://ttbilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://ttbilling.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentUAT = {
  production: false,
  baseUrl: "https://uat.nsurehub.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://uat.nsurehub.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "KxERLzJjnDJIYO7j67vKf2N3Zbtgt14e",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl: "https://uatbilling.preprodmiddleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey: "Weo0abc14ecbf4711ba3127d025dhn3ak",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  paymentPageName:"NsurehubPortal",
  SFpaymentResponseUrl: "https://uatbilling.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://uat.nsurehub.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://uatbilling.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://uatbilling.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentDev04 = {
  production: false,
  baseUrl: "https://dev04nsurehub.middleware.safepointdc.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://dev04nsurehub.middleware.safepointdc.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "YRTRLzGjnDJIyO7j8vef2N3nZqyt13eY",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl: "https://dev04billing.middleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey: "5y0def14-ehbf-4622-ba13-34d204aab3ae",
  paymentPageName:"NsurehubPortal",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  SFpaymentResponseUrl: "https://dev04billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://dev04nsurehub.middleware.safepointdc.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://dev04billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://dev04billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentPERF = {
  production: false,
  baseUrl: "https://perfnsurehub.preprodmiddleware.safepointdc.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://perfnsurehub.preprodmiddleware.safepointdc.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "Sh9FpQZx8cNpA5Yr2o5GdVkL6tUbWs7j",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl:"https://perfbilling.preprodmiddleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey:"Wp4Gh9JLjubE23a5Pc1k7nXfD6mRsYq2",
  paymentPageName:"NsurehubPortal",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  SFpaymentResponseUrl: "https://perfbilling.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://perfnsurehub.preprodmiddleware.safepointdc.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://perfbilling.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://perfbilling.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentDEBUG = {
  production: false,
  baseUrl: "https://debugnsurehub.preprodmiddleware.safepointdc.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://debugnsurehub.preprodmiddleware.safepointdc.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "Dm5KnVr8xOs1Pq5HtFb4WcYh7ZXuGah7",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl:"https://debugbilling.preprodmiddleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey:"Xe2PmKb1fWo8DhR6vNsJ3zGc5lQtYu9a",
  paymentPageName:"NsurehubPortal",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  SFpaymentResponseUrl: "https://debugbilling.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://debugnsurehub.preprodmiddleware.safepointdc.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://debugbilling.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://debugbilling.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentPROD = {
  production: true,
  baseUrl: "https://www.nsurehub.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://www.nsurehub.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "Pw7eR1TdBU9LoXc9UfA3zGpJm6N8hIWE",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl:"https://billing.pmiddleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey:"Hj6V8kLz5Np3DqY2WrT0Fx1G7BoE9iM",
  paymentPageName:"NsurehubPortal",
  SFpaymentURL: "https://internet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "D9m0NyBO2PlIEiQsgSzNYRzxdxuy64B0gBHLyUE85Sk=",
  CApaymentURL: "https://internet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "D9m0NyBO2PlIEiQsgSzNYRzxdxuy64B0gBHLyUE85Sk=",
  MNpaymentURL: "https://internet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "D9m0NyBO2PlIEiQsgSzNYRzxdxuy64B0gBHLyUE85Sk=",

  SFpaymentResponseUrl: "https://billing.pmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://www.nsurehub.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://billing.pmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://billing.pmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentUAT06 = {
  production: false,
  baseUrl: "https://uat2nsurehub.preprodmiddleware.safepointdc.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://uat2nsurehub.preprodmiddleware.safepointdc.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "IxELLtJjnDJKYO7j68vKf2HGZbtgt147",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl:"https://uat2billing.preprodmiddleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey:"Oeo0ubc14ijbf4711bu6127d025dhn3ay",
  paymentPageName:"NsurehubPortal",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  SFpaymentResponseUrl: "https://uat2billing.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://uat2nsurehub.preprodmiddleware.safepointdc.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://uat2billing.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://uat2billing.preprodmiddleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentDev05 = {
  production: false,
  baseUrl: "https://dev05nsurehub.middleware.safepointdc.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://dev05nsurehub.middleware.safepointdc.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "nV7xG4TqB2zP1hYc8JwR9mL0sF6uKdZ3",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl:"https://dev05billing.middleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey:"b2Tn5Yp9Kx3Rj7Vq0M4wL1Gz8C6hFvN",
  paymentPageName:"NsurehubPortal",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  SFpaymentResponseUrl: "https://dev05billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://dev05nsurehub.middleware.safepointdc.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://dev05billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://dev05billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};

export const environmentDev06 = {
  production: false,
  baseUrl: "https://dev06nsurehub.middleware.safepointdc.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://dev06nsurehub.middleware.safepointdc.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "h9TgP2qLxV7rWc8KmZ4sAf0NyBjD1uXH",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl:"https://dev06billing.middleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey:"c4Wv1Zf8GqT3sN0yR6jP9KxL5hM7bD2A",
  paymentPageName:"NsurehubPortal",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  SFpaymentResponseUrl: "https://dev06billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://dev06nsurehub.middleware.safepointdc.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://dev06billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://dev06billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};
export const environmentDev07 = {
  production: false,
  baseUrl: "https://dev07nsurehub.middleware.safepointdc.com/api/Nsurehub/",
  versiumAPIKEY: "f39f0806-10bd-4002-8e97-e1c751575963",
  googleKEY: "QUl6YVN5QmQ1LTBvd3F5dEgwOTk0S09pRkhxakIyNS16cVBZYWdz",
  datafinderURL: "https://api.versium.com/v2",
  infutorURL: "https://xml.yourdatadelivery.com",
  dcAPI: "https://dev07nsurehub.middleware.safepointdc.com/api/Nsurehub/",
  gicAPI: "https://api.vexcelgroup.com/v2",
  gicUserName: "TmlzaHRoYS5zb25pQGFnZ25lLmNvbQ==",
  gicPassword: "QWdnbmVAMTIz",
  debugEnabled: false,
  XApiKey: "Zq7LpXnDjFvRkT3m8sGh2Be5DgUa19eM",
  isPaymentGateWayACI:false,
  BillingHeartlandTokenUrl:"https://dev07billing.middleware.safepointdc.com/api/HeartLand/GenerateToken",
  BillingHeartlandApiKey:"Hr5XnQzMpDjVtK8m2fYe4B7cWgUsa36r",
  paymentPageName:"NsurehubPortal",
  SFpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  SFpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  CApaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  CApaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",
  MNpaymentURL: "https://batinternet.speedpay.com/api/cajunuw/sso?cid=CajunUWSSO",
  MNpaymentSecretKey: "3Tn0LH94ZMH+JGuVwIWGcoNVIpSaYjQtIySG1LAgIMA=",

  SFpaymentResponseUrl: "https://dev07billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubSafePoint",
  paymentStatusPage: "Portal|https://dev07nsurehub.middleware.safepointdc.com/paymentProcessAeg",
  CApaymentResponseUrl: "https://dev07billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubCajun",
  MNpaymentResponseUrl: "https://dev07billing.middleware.safepointdc.com/api/Billing/ASPX?Carrier=NsurehubManatee"
};
